<template>
	<div class="customer-list-wrapper">
		<div class="pull-right mb-4">
			<button type="submit" class="btn btn-warning" data-toggle="modal" data-target="#createCollaborator">
				Send a request
			</button>
		</div>
		<div class="customer-table">
			<table id="datatable" v-if="asyncDone" class="table table-striped table-bordered" cellspacing="0" width="100%">
				<thead>
					<tr>
						<th>Email</th>
						<th>Created</th>
						<th>Status</th>
						<th class="disabled-sorting text-right">Actions</th>
					</tr>
				</thead>
				<tfoot>
					<tr>
						<th>Email</th>
						<th>Created</th>
						<th>Status</th>
						<th class="disabled-sorting text-right">Actions</th>
					</tr>
				</tfoot>
				<tbody>
					<tr v-for="collaborator in collaborators" :key="collaborator.email">
						<td>{{ collaborator.email }}</td>
						<td class="sort-date">{{ collaborator.created | formatDate }}</td>
						<td>
							<span :class="(collaborator.status === 'pending') ? 'badge badge-warning' : 'badge badge-success'">
								{{collaborator.status}}
							</span>
						</td>
						<td class="text-center">
							<button title="View Domain List" class="btn btn-outline-info btn-sm mr-3" @click="viewDetail(collaborator)">
								<i class="fa fa-lock"></i>
							</button>
							<button class="btn btn-outline-danger btn-sm" @click="remove(collaborator)">
								<div class="loader mini_loader" v-if="action === 'remove' && selectedCollaborator.email === collaborator.email"></div>
								<i v-else class="fa fa-trash"></i>
							</button>
						</td>
				</tr>
				</tbody>
			</table>
		</div>
		<collaborator-create-modal v-on:update-list="list()"/>
		<collaborator-edit-modal v-on:update-list="list()" :collaborator="editCollaborator"/>
		<div class="modal fade" id="collaboratorDetail" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="editRecord" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title d-inline">{{selectedCollaborator.email}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<h6>Assign / Remove Domains</h6>
						<multi-select :clear-on-select="true" :close-on-select="false" :multiple="true"
								:options="domains" placeholder="Select Domain (s)"
								v-model="selectedCollaborator.domains"/>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-outline-primary btn-sm" @click="updateDomainInCollaborator()">
							<div class="loader mini_loader" v-if="action === 'update'"></div>
							<span v-else>Update</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import {db} from "@/firebase/init";
	import swal from "sweetalert2";
	import MultiSelect from 'vue-multiselect'
	import 'vue-multiselect/dist/vue-multiselect.min.css';
	import loginAsMixin from "../../../mixins/loginAsMixin";
	import dateMixin from "../../../mixins/dateMixin";
	import CollaboratorCreateModal from "./CollaboratorCreateModal";
	import CollaboratorEditModal from "./CollaboratorEditModal";
	import _ from 'lodash';

	export default {
		name: "SupervisorList",
		mixins: [loginAsMixin, dateMixin],
		data() {
			return {
				editCollaborator: {},
				collaborators: [],
				noUser: false,
				action: '',
				selectedCollaborator: {}
			};
		},
		components: {
			MultiSelect,
			CollaboratorCreateModal,
			CollaboratorEditModal
		},
		computed: {
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			user() {
				return this.$store.getters.user;
			},
			userToken() {
				return this.$store.getters.getUserToken;
			},
			domains() {
				const accounts = this.$store.getters['hosting/accounts'];
				let domains = [];
				for(const account of accounts){
					domains.push(account.primary.domain);
					for(let adon of account.addon){
						domains.push(adon.domain);
					}
				}
				return domains;
			}
		},
		methods: {
			viewDetail(collaborator) {
				console.log(collaborator);
				this.selectedCollaborator = collaborator;
				/* eslint-disable */
				$("#collaboratorDetail").modal('show');
				/* eslint-enable */
			},
			async updateDomainInCollaborator(){
				this.action = 'update';
				console.log(this.collaborators);
				await db.collection('users').doc(this.user.uid).update({
					collaborators: this.collaborators
				});

				if(this.selectedCollaborator.uid !== ''){
					const collaboratorData = await db.collection('users').doc(this.selectedCollaborator.uid).get();
					if(collaboratorData.exists){
						const allSupervisors = collaboratorData.data()['supervisors'];
						for(let supervisor of allSupervisors){
							if(supervisor.supervisorId === this.user.uid){
								supervisor.allowedDomains = this.selectedCollaborator.domains;
								break;
							}
						}
						await db.collection('users').doc(this.selectedCollaborator.uid).update({
							supervisors: allSupervisors
						})
					}
				}
				/* eslint-disable */
				$("#collaboratorDetail").modal('hide');
				/* eslint-enable */
				swal('Success!', 'Collaborator has been updated!', 'success');
				this.action = '';
			},
			list() {
				this.collaborators = [];
				return db.collection("users")
					.doc(this.user.uid)
					.get()
					.then(doc => {
						const userData = doc.data();
						if (userData.collaborators && userData.collaborators.length > 0){
							this.collaborators = _.cloneDeep(userData.collaborators);
						}
					})
					.catch(err => {
						// Show error message to the customer for 5 sec
						this.$store.dispatch("alert/update", {
							type: "danger",
							message: err.name,
							show: true
						});
					})
					.finally(() => {
						setTimeout(() => {
							this.$store.dispatch("alert/showUpdate", {show: false});
						}, 5000);
					});
			},
			remove(collaborator) {
				this.selectedCollaborator = collaborator;
				swal({
					title: "Removing collaborator",
					html: "Are you sure that you want to remove <b>" + collaborator.email + "</b> access to your" +
							" account? You may re-add it at any time.",
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							// Set asyncDone to false
							this.action = 'remove';
							this.collaborators = this.collaborators.filter(item => item.email !== collaborator.email);
							db.collection('users').doc(this.user.uid).update({
								collaborators: this.collaborators
							}).then(async () => {
								/* eslint-disable */
								$("#collaboratorDetail").modal('hide');
								/* eslint-enable */
								if(collaborator.uid !== ''){
									const supervisorsRef = await db.collection('users').doc(collaborator.uid).get();
									let supervisors = supervisorsRef.data()['supervisors'];
									supervisors = supervisors.filter(item => item.supervisorEmail !== this.user.email);
									await db.collection('users').doc(collaborator.uid).update({
										supervisors: supervisors
									});
								}
								swal('Success!', 'Collaborator has been removed!', 'success');
							}).finally(() => {
								this.action = '';
							});
						}
					})
			}
		},
		created() {
			this.list();
		},
		mounted() {
			/* eslint-disable */
			$('#editCollaborator').on('hide.bs.modal', () => {
				this.editCollaborator = {};
			});
			/* eslint-enable */
		},
		updated() {
			const deleteuser = this.delete
			/* eslint-disable */
			$("#datatable").on("click", ".remove", function () {
				const docID = $(this).attr("data");
				deleteuser(docID)
			});
			/* eslint-enable */
		}
	};
</script>
